import { createContext, useContext, useMemo } from 'react';
import useFormRouting from 'FormsUI/components/hooks/routing/useFormRouting';
import useUpsertRouting from 'FormsUI/api/dataFetchingClient/hooks/useUpsertRouting';
import useFetchFormRouting from 'FormsUI/api/dataFetchingClient/hooks/useFetchFormRouting';
import useAutosaveRouting from 'FormsUI/components/hooks/routing/useAutosaveRouting';
import { jsx as _jsx } from "react/jsx-runtime";
const FormRoutingContext = /*#__PURE__*/createContext(undefined);
const FormRoutingProvider = ({
  children
}) => {
  const {
    updateRouting,
    loading: updateRoutingLoading,
    error: updateRoutingError
  } = useUpsertRouting();
  const {
    formRouting: formRoutingFromResponse,
    formRoutingLoading
  } = useFetchFormRouting();
  const {
    routing,
    actions
  } = useFormRouting();
  const {
    formRouting
  } = routing;
  useAutosaveRouting({
    formRouting,
    formRoutingFromResponse,
    updateRouting
  });
  const loading = useMemo(() => ({
    formRoutingLoading,
    updateRoutingLoading
  }), [formRoutingLoading, updateRoutingLoading]);
  const errors = useMemo(() => ({
    updateRoutingError
  }), [updateRoutingError]);
  const value = useMemo(() => ({
    routing,
    actions,
    loading,
    errors
  }), [routing, actions, loading, errors]);
  return /*#__PURE__*/_jsx(FormRoutingContext.Provider, {
    value: value,
    children: children
  });
};
export const useFormRoutingContext = () => {
  const context = useContext(FormRoutingContext);
  if (context === undefined) {
    throw new Error('useFormRoutingContext must be used within a FormRoutingProvider');
  }
  return context;
};
export default FormRoutingProvider;